exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-profile-custom input,.my-profile-custom select{border-color:#D6D8DE}\n", ""]);

// exports
